<template>
    <div>
        <limitless-page-header title="Supékort SMS" />

        <div class="content">
            <div v-if="success_message" class="alert alert-success" role="status">{{ success_message }}</div>
            <div v-if="error_message" class="alert alert-danger" role="alert">{{ error_message }}</div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-lg-6">
                            <ValidationObserver ref="smsform">
                                <form @submit.prevent="sendSms" :aria-busy="busy_sending">
                                    <input-with-validation
                                        v-model="sms.from"
                                        vid="from"
                                        label="Avsändare"
                                        rules="required"
                                        :disabled="busy_sending"
                                    />
                                    <div class="mb-3">
                                        <button
                                            v-for="sender in senders"
                                            :key="sender"
                                            type="button"
                                            class="btn btn-link p-0 mr-2"
                                            :disabled="busy_sending"
                                            @click="sms.from = sender"
                                        >{{ sender }}</button>
                                    </div>

                                    <input-with-validation
                                        v-model="sms.to"
                                        vid="to"
                                        label="Mottagare"
                                        type="tel"
                                        rules="required"
                                        placeholder="ex. +46702246000"
                                        :disabled="busy_sending"
                                    />
                                    <textarea-with-validation
                                        v-model="sms.message"
                                        vid="message"
                                        label="Meddelande"
                                        rules="required"
                                        placeholder="Skriv ett meddelande..."
                                        :rows="12"
                                        :strip-tags="false"
                                        :disabled="busy_sending"
                                    />

                                    <limitless-button
                                        ref="btnsendsms"
                                        type="submit"
                                        icon="icon-paperplane"
                                        saved-text="Skickat!"
                                        error-text="Kunde inte skicka"
                                        :busy="busy_sending"
                                        :disabled="!can_send"
                                    >Skicka SMS</limitless-button>
                                </form>
                            </ValidationObserver>
                        </div>

                        <div class="col-lg-6 mt-4 mt-lg-0">
                            <table class="table" aria-label="Meddelandets längd och antal SMS">
                                <tbody>
                                    <tr>
                                        <th scope="row">Encoding</th>
                                        <td class="text-right">{{ sms_count.encoding }}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Antal SMS</th>
                                        <td class="text-right">{{ sms_count.messages }}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Antal tecken</th>
                                        <td class="text-right">{{ sms_count.length }}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Tecken per SMS</th>
                                        <td class="text-right">{{ sms_count.characterPerMessage }}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Tecken kvar i aktuellt SMS</th>
                                        <td class="text-right">{{ sms_count.remaining }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { count } from 'sms-length';
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import InputWithValidation from '@components/Form/InputWithValidation';
import TextareaWithValidation from '@components/Form/TextareaWithValidation';
import LimitlessButton from '@components/Limitless/LimitlessButton';
import apiClient from '@services/ApiClient';

export default {
    name: 'SendSms',
    components: {
        LimitlessPageHeader,
        InputWithValidation,
        TextareaWithValidation,
        LimitlessButton,
    },
    data: () => ({
        senders: ['Supekort', 'NewportHome', 'newport.se'],
        sms: {
            from: 'Supekort',
            to: '',
            message: '',
        },
        busy_sending: false,
        success_message: '',
        error_message: '',
    }),
    computed: {
        sms_count() {
            return count(this.sms.message);
        },
        can_send() {
            return Boolean(this.sms.from.trim() && this.sms.to.trim() && this.sms.message.trim());
        },
    },
    methods: {
        async sendSms() {
            if (this.busy_sending || !this.can_send) {
                return;
            }

            this.busy_sending = true;
            this.success_message = '';
            this.error_message = '';

            try {
                const isValid = await this.$refs.smsform.validate();
                if (!isValid) {
                    return;
                }

                const payload = {
                    from: this.sms.from.trim(),
                    to: this.sms.to.trim(),
                    message: this.sms.message,
                };
                await apiClient.post('/vue/sms/send', payload);
                this.success_message = 'SMS:et har skickats till ' + payload.to + '.';
                this.$refs.btnsendsms.triggerSaved();
                this.sms.message = '';
                await this.$nextTick();
                this.$refs.smsform.reset();
            } catch (error) {
                if (error.response?.status === 422 && error.response.data?.errors) {
                    this.$refs.smsform.setErrors(error.response.data.errors);
                    this.error_message = 'Kontrollera de markerade fälten.';
                } else {
                    this.error_message = error.response?.data?.message || 'SMS:et kunde inte skickas. Försök igen.';
                }
                this.$refs.btnsendsms.triggerFailed();
            } finally {
                this.busy_sending = false;
            }
        },
    },
};
</script>
